import { render, staticRenderFns } from "./SvCheckbox.vue?vue&type=template&id=147b39de&scoped=true&lang=pug&"
import script from "./SvCheckbox.vue?vue&type=script&lang=js&"
export * from "./SvCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SvCheckbox.vue?vue&type=style&index=0&id=147b39de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b39de",
  null
  
)

export default component.exports